import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
    selector: 'app-result-dialog',
    templateUrl: './result-dialog.component.html',
    styleUrls: ['./result-dialog.component.css'],
    standalone: false
})
export class ResultDialogComponent {
    title: string;
    body: string;
    innerHTML: string;

    constructor(
        public dialogRef: MatDialogRef<ResultDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { title: string; body: string; innerHTML: string }
    ) {
    // Update view with given values
        this.title = data.title;
        this.body = data.body;
        this.innerHTML = data.innerHTML;
    }

    onConfirm(): void {
    // Close the dialog, return true
        this.dialogRef.close(true);
    }

    onDismiss(): void {
    // Close the dialog, return true
        this.dialogRef.close(true);
    }
}
